import React from 'react';
import { IconBase, IconProps } from '../IconBase';

export const PlayIcon = ({ size, color, title, onClick, decorative, ...restItems }: IconProps) => (
	<IconBase
		viewBox="0 0 52 52"
		size={size}
		color={color}
		title={title}
		onClick={onClick}
		decorative={decorative}
		{...restItems}
	>
		<g filter="url(#filter0_dd_1817_68120)">
			<path
				d="M6 22C6 10.9543 14.9543 2 26 2C37.0457 2 46 10.9543 46 22C46 33.0457 37.0457 42 26 42C14.9543 42 6 33.0457 6 22Z"
				fill="#6AB0BA"
			/>
			<path
				d="M21.5 27.5L30.5 22L21.5 16.5V27.5ZM20.75 15.2188C21.2188 14.9375 21.8125 14.9375 22.2812 15.2188L31.2812 20.7188C31.7188 21 32 21.5 32 22C32 22.5312 31.7188 23.0312 31.2812 23.2812L22.2812 28.7812C21.8125 29.0938 21.2188 29.0938 20.75 28.8125C20.2812 28.5625 20 28.0625 20 27.5V16.5C20 15.9688 20.2812 15.4688 20.75 15.2188Z"
				fill="white"
			/>
		</g>
		<defs>
			<filter
				id="filter0_dd_1817_68120"
				x="0"
				y="0"
				width="52"
				height="52"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1817_68120" />
				<feOffset dy="2" />
				<feGaussianBlur stdDeviation="2" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1817_68120" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1817_68120" />
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_1817_68120" result="effect2_dropShadow_1817_68120" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1817_68120" result="shape" />
			</filter>
		</defs>
	</IconBase>
);
